// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sj7L9F5un5FljMx6N47P {
    height: 90vh !important;
    width: 80vw !important;
}

.l3JHHrIMiAi52RXxBYTa {
    display: grid;
    grid-template-rows: 1fr 1fr 7fr;
    height: 80vh;
    padding: 20px;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/plugins/widen-library/admin/src/components/WidenLibrary/WidenLibrary.module.css"],"names":[],"mappings":"AAAA;IACI,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,+BAA+B;IAC/B,YAAY;IACZ,aAAa;IACb,WAAW;AACf","sourcesContent":[".modal-container {\n    height: 90vh !important;\n    width: 80vw !important;\n}\n\n.search-container {\n    display: grid;\n    grid-template-rows: 1fr 1fr 7fr;\n    height: 80vh;\n    padding: 20px;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-container": `sj7L9F5un5FljMx6N47P`,
	"search-container": `l3JHHrIMiAi52RXxBYTa`
};
export default ___CSS_LOADER_EXPORT___;
